// Dependencies
import React from "react";
import { Icon as AntdIcon } from "antd";
import PropTypes from "prop-types";
import { css } from "emotion";

const Icon = ({ type, color, size, disabled, ...props }) => {
  return (
    <AntdIcon
      type={type}
      className={css`
        padding: 0 5px;
        cursor: ${props.onClick && "pointer"};
        font-size: ${size};
        color: ${disabled ? "#ccc" : color};
        pointer-events: ${disabled && "none"};
      `}
      {...props}
    />
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
};

Icon.defaultProps = {
  color: "#000000",
  size: "20px",
};

export default Icon;
